import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRegisterPayload {
    data: any
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const registerSlice = createSlice({
    name: 'chat/register-user',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IRegisterPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.messages
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const registerActions = registerSlice.actions
export default registerSlice.reducer
